import React from 'react';
import TypographyVariants from './types/VariantsType';
import TypographyTags from './types/TagsType';
import styles from './Typography.module.scss';
// @ts-ignore
import classNames from 'classnames';

type variantConfig = {
    [variant in TypographyVariants]?: string;
} & {
    basic?: string;
};

type PropsType = {
    className?: string,
    variant: TypographyVariants,
    tag?: TypographyTags,
    uppercase?: boolean,
    children?: React.ReactElement,
    /**
     * Expected object as variantConfig type
     */
    variantConfig?: variantConfig
};

const Typography = (props: PropsType) => {
    const tagType = props.tag || props.variant;
    const classTag = classNames(
        styles.wrapper,
        props.className,
        props.variant && styles[`variant-${props.variant}`],
        props.uppercase && styles.uppercase
    );

    // if (props.variantConfig && props.variantConfig[props.variant]) {
    //     const VariantTagExtended = styled(VariantTag)`
    //         font-size: ${props.variantConfig[props.variant]}
    //     `;

    //     return (
    //         <VariantTagExtended 
    //             className={classNames(
    //                 props.className,
    //                 props.uppercase && styles.uppercase)
    //             }
    //         >
    //             {props.children}
    //         </VariantTagExtended>
    //     )
    // }

    switch(tagType) {
        case TypographyVariants.H1:
            return <h1 className={classTag}>{props.children}</h1>;
        case TypographyVariants.H2:
            return <h2 className={classTag}>{props.children}</h2>;
        case TypographyVariants.H3:
            return <h3 className={classTag}>{props.children}</h3>;
        case TypographyVariants.Span:
            return <span className={classTag}>{props.children}</span>;
        case TypographyVariants.Paragraph:
            return <p className={classTag}>{props.children}</p>;
        default:
            return null;
    }
};

Typography.Variants = TypographyVariants;
Typography.Tags = TypographyTags;

export default Typography;